<app-head-bar class="headbar" *ngIf="isHeadbarVisible | async" />

<main
  id="mainLayout"
  class="main"
  [class.headbar-visible]="isHeadbarVisible | async"
  [class.navigation-visible]="isNavigationVisible | async">
  <div class="main-wrapper">
    <router-outlet />
  </div>
  <p-toast></p-toast>
  <div *ngIf="isNavigationLoading$ | async" class="navigation-loading-overlay">
    <div class="navigation-loading-overlay-spinner">
      <app-dot-spinner />
    </div>
  </div>
</main>

<app-navigation *ngIf="isNavigationVisible | async" />
